/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIMeasurementRequest
 */
export interface APIMeasurementRequest {
    /**
     * 
     * @type {string}
     * @memberof APIMeasurementRequest
     */
    unit: string;
    /**
     * 
     * @type {string}
     * @memberof APIMeasurementRequest
     */
    value: string;
}

/**
 * Check if a given object implements the APIMeasurementRequest interface.
 */
export function instanceOfAPIMeasurementRequest(value: object): value is APIMeasurementRequest {
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function APIMeasurementRequestFromJSON(json: any): APIMeasurementRequest {
    return APIMeasurementRequestFromJSONTyped(json, false);
}

export function APIMeasurementRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIMeasurementRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'unit': json['unit'],
        'value': json['value'],
    };
}

export function APIMeasurementRequestToJSON(value?: APIMeasurementRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'unit': value['unit'],
        'value': value['value'],
    };
}

